module.exports = __webpack_public_path__ + "static/img/AMKG.7f23722.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/AMKG.png
// module id = hdOT
// module chunks = 1